import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import React from 'react';

import { ArrowLeftIcon } from '../../icons';

const StyledIconButton = styled(IconButton)({
  '& .MuiTouchRipple-child': {
    backgroundColor: `#f6f8fa !important`,
  },
});

interface BackButtonProps extends IconButtonProps {
  iconSize?: number;
}

export const BackButton = ({ iconSize = 20, ...props }: BackButtonProps) => {
  return (
    <StyledIconButton
      aria-label="back"
      color="primary"
      sx={{
        width: iconSize * 2,
        height: iconSize * 2,
      }}
      {...props}
    >
      <ArrowLeftIcon
        sx={{
          fontSize: iconSize,
        }}
      />
    </StyledIconButton>
  );
};
